import React from 'react';
import { AlertCircle, MessageSquare, Megaphone, Camera } from 'lucide-react';

const Problems = () => {
  const problems = [
    {
      icon: MessageSquare,
      text: 'Informasi wisuda tersebar di berbagai kanal'
    },
    {
      icon: AlertCircle,
      text: 'Pertanyaan peserta berulang dan menyita waktu panitia'
    },
    {
      icon: Megaphone,
      text: 'Pengumuman hari-H tidak diterima secara merata'
    },
    {
      icon: Camera,
      text: 'Dokumentasi hanya bersifat formal dan terbatas'
    }
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-br from-terracotta-50 to-cream-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Masalah yang Sering Terjadi<br />Saat Wisuda
          </h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            Dalam acara wisuda berskala besar, tantangan berikut hampir selalu muncul:
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-6">
          {problems.map((problem, index) => (
            <div 
              key={index}
              className="group p-8 bg-white/80 backdrop-blur-sm rounded-2xl border border-terracotta-100 hover:border-terracotta-300 transition-all duration-300 hover:shadow-lg"
            >
              <div className="flex items-start gap-4">
                <div className="p-3 bg-terracotta-100 rounded-xl group-hover:bg-terracotta-200 transition-colors">
                  <problem.icon className="w-6 h-6 text-terracotta-600" />
                </div>
                <p className="text-lg text-gray-800 leading-relaxed pt-2">
                  {problem.text}
                </p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-12 p-6 bg-white/60 backdrop-blur-sm rounded-2xl border border-terracotta-200 text-center">
          <p className="text-lg text-gray-700 italic">
            Kondisi ini dapat mengurangi ketertiban acara dan pengalaman wisudawan.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Problems;
